import {Button, Col, Form, Row, Space, Table, message} from "antd";
import React, {useState, useEffect} from "react";
import {nurseOutService} from "api";
import {fields} from "./config";
import {InputFields} from "components/common";
import moment from "moment";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import Notification from "components/common/notification/notification";
import {getListLichsuTraThuocAPI, setIdPhieu} from "redux/reducer/nurseOut";
const ModalContent = props => {
  const dispatch = useAppDispatch();
  const [currentDilate, setCurrentDilate] = useState<any>();
  const {dilate, getListPhieu} = props;
  const [listDilate, setListDilate] = useState<any[]>();
  const [form] = Form.useForm();
  const idPhieu = useAppSelector(state => state.nurseOut.idPhieu);
  const lichSuTra = useAppSelector(state => state.nurseOut.listLichSuTra);
  useEffect(() => {
    getListDilate();
  }, []);
  useEffect(() => {
    if (idPhieu != null) {
      dispatch(getListLichsuTraThuocAPI(idPhieu));
    }
  }, [idPhieu]);
  useEffect(() => {
    if (lichSuTra.length > 0) {
      const data = lichSuTra[0];
      setCurrentDilate(data);
      form.setFieldsValue(data);
    }
  }, [lichSuTra]);
  const traThuoc = async () => {
    const data = {
      ...currentDilate,
      thoiGianTraThuoc: moment().toISOString(),
      isStop: true,
    };
    try {
      const res = await nurseOutService.stopTraThuoc(currentDilate?.id, data);
      Notification("success", "Cập nhật tra thuốc thành công");
      if (getListPhieu) {
        getListPhieu();
      }
    } catch (error) {
      Notification("error", "Đã có lỗi khi dừng tra thuốc");
    }
  };
  useEffect(() => {}, []);
  const getListDilate = async () => {
    try {
      const res = await nurseOutService.getListDilate();
      setListDilate(res);
      const optionsDilate = res.map(e => {
        return {
          value: e.tenVietTat,
          label: e.tenThuocTra,
        };
      });

      fields[0].options = optionsDilate;
    } catch (error) {
      Notification("error", "Đã có lỗi khi tải danh sách thuốc tra");
    }
  };
  const onClickDilate = async () => {
    var dilateData = form.getFieldsValue();
    dilateData = {
      ...dilateData,
      id: "",
      thoiGianTraThuoc: moment().toISOString(),
      isStop: false,
      idPhieuDieuDuong: idPhieu,
    };
    try {
      const res = await nurseOutService.postTraThuoc(dilateData);
      dilateData.id = res.id;
      Notification("success", "Tra thuốc thành công");
      // dilate(dilateData);
      dispatch(setIdPhieu(null));
      if (getListPhieu) {
        getListPhieu();
      }

      closeModal();
    } catch (error) {
      Notification("error", "Đã có lỗi khi tra thuốc");
    }
  };

  const {closeModal} = props;
  return (
    <Space direction="vertical" style={{width: "100%"}}>
      <Form form={form} onFinish={onClickDilate}>
        <Row gutter={[16, 16]}>
          {listDilate && <InputFields data={fields}></InputFields>}
        </Row>
        <Row justify={"end"} style={{marginTop: 12}}>
          <Col>
            <Space>
              {!currentDilate?.isStop && (
                <Button
                  danger
                  type="primary"
                  onClick={() => {
                    traThuoc();
                    closeModal();
                    dispatch(setIdPhieu(null));
                  }}
                >
                  Dừng tra
                </Button>
              )}
              <Button danger type="primary" onClick={closeModal}>
                Hủy bỏ
              </Button>{" "}
              <Button type="primary" htmlType="submit">
                Lưu lại
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Space>
  );
};
export default ModalContent;
